<style lang="scss" scoped></style>

<template>
  <div class="w-full bg-#10131A pb-24px pt-40px">
    <div class="m-[0_auto] w-1200px">
      <div class="mb-6 flex gap-25 border-b border-b-#1C222E border-b-solid pb-10">
        <div>
          <div class="mb-64px h-10 w-208px bg-[url(@/assets/image/logo-bottom.png)] bg-cover bg-no-repeat"></div>
          <div class="bg-#002FBE p-2 text-4 text-white">周一至周日：08:00-20:00</div>
        </div>
        <div class="flex text-20px text-white font-semibold">
          <div class="mr-15 cursor-pointer" @click="toPage('/operation')">运营推广</div>
          <div class="mr-15 cursor-pointer" @click="toPage('/cooperation')">合作案例</div>
          <div class="mr-80px cursor-pointer" @click="toPage('/about')">关于我们</div>
          <div>
            <div class="mb-10 flex items-center">
              <img src="@/assets/image/footer-zx-icon.png" class="mr-2 h-5 w-5" alt="" />
              业务咨询：13057628160
            </div>
            <div class="flex items-center">
              <img src="@/assets/image/footer-ts-icon.png" class="mr-2 h-5 w-5" alt="" />
              投诉热线：18551612127
            </div>
          </div>
        </div>
        <div>
          <div class="mb-4 text-center text-4 text-white font-semibold">业务咨询</div>
          <div class="h-25 w-25 bg-[url(@/assets/image/qr-code.png)] bg-cover bg-no-repeat"></div>
        </div>
      </div>
      <div class="text-center text-14px text-#929AAA">
        Copyright 2024 www.yiyuan.red All Rights Reserved.鲁ICP备2024116691号-1青岛易源网络科技有限责任公司 版权所有
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const toPage = (path) => {
  router.push(path)
}
</script>
